import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <h4>All rights reserved. Samsara Therapy</h4>
      </div>
    );
  }
}

export default Footer;
